<div
  class="container pia-mainContainerBlock"
  [ngClass]="{
    'pia-mainContainerBlock-structures':
      appDataService.entrieMode === 'structure',
    'pia-mainContainerBlock-archives': appDataService.entrieMode === 'archive',
    'pia-mainContainerBlock-knowledges':
      appDataService.entrieMode === 'knowledgeBase'
  }"
>
  <div class="row">
    <div class="small-12 medium-12 columns">
      <div class="pia-breadcrumb">
        <strong>
          @if (type_entries === 'pia' || type_entries === 'archive') {
          {{ "header.homepage_link" | translate }}
          } @if (type_entries === 'pia') {
          {{ "header.current_pias" | translate }}
          } @if (type_entries === 'structure') {
          {{ "header.structures" | translate }}
          } @if (type_entries === 'archive') {
          {{ "header.archives" | translate }}
          } @if (type_entries === 'knowledgeBase') {
          {{ "header.knowledge_base_link" | translate }}
          }
        </strong>
      </div>
      <div class="pia-filtersBlock">
        <div class="pia-filtersBlock-left">
          @if (viewStyle.view === 'list') {
          <button
            class="pia-filtersBlock-switch btn"
            type="button"
            (click)="viewOnCard()"
          >
            <fa-icon [icon]="faList"></fa-icon>
            <div>{{ "homepage.filters.card" | translate }}</div>
          </button>
          } @if (viewStyle.view === 'card') {
          <button
            class="pia-filtersBlock-switch btn"
            type="button"
            (click)="viewOnList()"
          >
            <fa-icon [icon]="faList"></fa-icon>
            <div>{{ "homepage.filters.list" | translate }}</div>
          </button>
          } @if (type_entries === 'pia' || type_entries === 'structure' ||
          type_entries === 'knowledgeBase') { @if (!authService.state ||
          (showPiaForm && viewStyle.view === 'list')) {
          <div class="pia-filtersBlock-buttons">
            <button
              type="button"
              class="btn"
              [ngClass]="
                appDataService.entrieMode === 'knowledgeBase'
                  ? 'btn-red'
                  : 'btn-green'
              "
              (click)="showModal = true"
            >
              <fa-icon [icon]="faFolderOpen"></fa-icon>
              @if (type_entries === 'pia') {
              {{ "homepage.cards.new_pia" | translate }}
              } @if (type_entries === 'structure') {
              {{ "homepage.cards.new_structure" | translate }}
              } @if (type_entries === 'knowledgeBase') {
              {{ "homepage.cards.knowledges.new" | translate }}
              }
            </button>
            <button
              type="button"
              class="btn"
              [ngClass]="
                appDataService.entrieMode === 'knowledgeBase'
                  ? 'btn-red'
                  : 'btn-green'
              "
              (click)="import()"
            >
              <fa-icon [icon]="faUpload"></fa-icon>
              @if (type_entries === 'pia') {
              {{ "homepage.cards.import_pia" | translate }}
              } @if (type_entries === 'structure') {
              {{ "homepage.cards.import_structure" | translate }}
              } @if (type_entries === 'knowledgeBase') {
              {{ "homepage.cards.knowledges.import" | translate }}
              }
            </button>
          </div>
          } @if (viewStyle.view === 'list' && entries && entries.length === 0) {
          <div class="pia-filtersBlock-hint">
            <div>
              <span class="pia-icons pia-icon-rocket-small"></span>
              <p
                [innerHTML]="'homepage.filters.list_rocket_content' | translate"
              ></p>
            </div>
          </div>
          }
          <div class="hide">
            <form enctype="multipart/form-data" [formGroup]="importForm">
              <input
                type="file"
                formControlName="import_file"
                id="import_file"
                (change)="import($event)"
                class="hide"
              />
            </form>
            <a href="" id="pia-exportBlock"></a>
          </div>
          }
        </div>

        <div class="pia-filtersBlock-right">
          @if (viewStyle.view === 'card') {
          <div class="pia-filtersBlock-filters">
            <button class="pia-filtersBlock-filters-btn btn" type="button">
              <fa-icon [icon]="faFilter"></fa-icon>
              {{ "homepage.filters.sort" | translate }}
              <span
                class="pia-icons"
                [ngClass]="
                  appDataService.entrieMode === 'knowledgeBase'
                    ? 'pia-icon-scroll-red'
                    : 'pia-icon-scroll-green'
                "
              ></span>
            </button>
            <div class="pia-filtersBlock-filters-list">
              <span>{{ "homepage.filters.sort_by" | translate }}</span>
              <ul>
                @switch (type_entries) { @case ('structure') {
                <li [ngClass]="{ active: sortValue === 'name' }">
                  <a (click)="sortBy('name')">{{
                    "homepage.filters.name" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'sector_name' }">
                  <a (click)="sortBy('sector_name')">{{
                    "homepage.filters.sector_name" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'created_at' }">
                  <a (click)="sortBy('created_at')">{{
                    "homepage.filters.date" | translate
                  }}</a>
                </li>
                } @case ('knowledgeBase') {
                <li [ngClass]="{ active: sortValue === 'name' }">
                  <a (click)="sortBy('name')">{{
                    "homepage.filters.name" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'author' }">
                  <a (click)="sortBy('author')">{{
                    "homepage.cards.knowledges.placeholder_author" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'contributors' }">
                  <a (click)="sortBy('contributors')">{{
                    "homepage.cards.knowledges.placeholder_contributors"
                      | translate
                  }}</a>
                </li>
                } @default {
                <li [ngClass]="{ active: sortValue === 'name' }">
                  <a (click)="sortBy('name')">{{
                    "homepage.filters.name" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'category' }">
                  <a (click)="sortBy('category')">{{
                    "homepage.filters.category" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'created_at' }">
                  <a (click)="sortBy('created_at')">{{
                    "homepage.filters.date" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'status' }">
                  <a (click)="sortBy('status')">{{
                    "homepage.filters.status" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'author_name' }">
                  <a (click)="sortBy('author_name')">{{
                    "homepage.filters.author" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'evaluator_name' }">
                  <a (click)="sortBy('evaluator_name')">{{
                    "homepage.filters.assessor" | translate
                  }}</a>
                </li>
                <li [ngClass]="{ active: sortValue === 'validator_name' }">
                  <a (click)="sortBy('validator_name')">{{
                    "homepage.filters.validator" | translate
                  }}</a>
                </li>
                } }
              </ul>
            </div>
          </div>
          }

          <div class="pia-searchInput">
            <input
              type="text"
              class="btn btn-search"
              [ngClass]="{ typed: searchText && searchText.length > 0 }"
              [(ngModel)]="searchText"
              placeholder="{{ 'homepage.search_filter' | translate }}"
              name="search"
              autocomplete="off"
            />
            <i class="search-icon">⚲</i>
            @if (searchText && searchText.length > 0) {
            <i class="search-close" (click)="onCleanSearch()">×</i>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- "Card" mode -->
    @if (viewStyle.view === 'card') {
    <div class="small-12 medium-12 columns pia-list">
      <!-- New PIA -->
      @if (showPiaForm && (type_entries === 'pia' || type_entries ===
      'structure' || type_entries === 'knowledgeBase')) {
      <div class="pia-cardsBlock pia-newBlock" id="cardsSwitch">
        <div class="pia-newBlock-item front" id="pia-new-card">
          <div class="pia-newBlock-item-new">
            <div class="pia-newBlock-item-new-title">
              @if (type_entries === 'pia') {
              {{ "homepage.cards.new_pia" | translate }}
              } @if (type_entries === 'structure') {
              {{ "homepage.cards.new_structure" | translate }}
              } @if (type_entries === 'knowledgeBase') {
              {{ "homepage.cards.knowledges.new" | translate }}
              }
            </div>
            <div class="pia-newBlock-item-new-btn">
              <fa-icon [icon]="faFolderOpen"></fa-icon>
              <button
                class="btn"
                (click)="open()"
                type="button"
                [attr.title]="
                  'homepage.cards.placeholder_new_' + type_entries | translate
                "
              >
                <span
                  class="pia-icons"
                  [ngClass]="
                    appDataService.entrieMode === 'knowledgeBase'
                      ? 'pia-icon-pia-plus-red'
                      : 'pia-icon-pia-plus'
                  "
                ></span>
              </button>
            </div>
          </div>
          <span>{{ "homepage.cards.or" | translate }}</span>
          <div class="pia-newBlock-item-import">
            <div class="pia-newBlock-item-import-title">
              @if (type_entries === 'pia') {
              {{ "homepage.cards.import_pia" | translate }}
              } @if (type_entries === 'structure') {
              {{ "homepage.cards.import_structure" | translate }}
              } @if (type_entries === 'knowledgeBase') {
              {{ "homepage.cards.knowledges.import" | translate }}
              }
            </div>
            <div class="pia-newBlock-item-import-btn">
              <fa-icon [icon]="faUpload"></fa-icon>
              <button
                class="btn"
                (click)="import()"
                type="button"
                [attr.title]="
                  'homepage.cards.placeholder_import_' + type_entries
                    | translate
                "
              >
                <span
                  class="pia-icons"
                  [ngClass]="
                    appDataService.entrieMode === 'knowledgeBase'
                      ? 'pia-icon-pia-plus-red'
                      : 'pia-icon-pia-plus'
                  "
                ></span>
              </button>
            </div>
          </div>
        </div>
        <div class="pia-cardsBlock pia-editBlock back">
          <div class="pia-cardsBlock-item pia-editBlock-item">
            <button
              class="btn"
              (click)="reverse()"
              type="button"
              [attr.title]="'homepage.cards.title_close_creation' | translate"
            >
              <span class="pia-icons pia-icon-close"></span>
            </button>

            @switch (type_entries) { @case ('pia') {
            <app-new-pia
              [users]="users"
              (newUserNeeded)="onNewUserNeeded($event)"
              (submitted)="onFormsubmitted($event, 'pia')"
            >
            </app-new-pia>
            } @case ('structure') {
            <app-new-structure
              (submitted)="onFormsubmitted($event, 'structure')"
            >
            </app-new-structure>
            } @case ('knowledgeBase') {
            <app-new-knowledgebase
              (submitted)="onFormsubmitted($event, 'knowledgeBase')"
            >
            </app-new-knowledgebase>
            } @default { } }
          </div>
        </div>
      </div>
      }
      <!-- END New PIA -->
      @if (!loading) {

      <!-- PIA, ARCHIVE Cards switch -->
      @switch (type_entries) { @case ('pia') { @if (entries.length <= 0 &&
      !loading) {
      <div class="no-pia">
        {{ "homepage.no_entries.pia" | translate }}
      </div>
      } @for (pia of entries | filterForUser: searchText; let i = $index; track
      pia.id) {
      <app-pia-card
        [users]="users"
        (conflictDetected)="conflictDialog($event)"
        (newUserNeeded)="onNewUserNeeded($event)"
        (changed)="updateEntrie($event)"
        (duplicated)="refreshContent()"
        (archived)="refreshContent()"
        [pia]="pia"
        [previousPia]="i > 0 ? entries[i - 1] : null"
      >
      </app-pia-card>
      } } @case ('archive') { @if (entries.length <= 0) {
      <div class="no-pia">
        {{ "homepage.no_entries.archive" | translate }}
      </div>
      } @for (archivedPia of entries | filterForUser: searchText; let i =
      $index; track archivedPia.id) {
      <app-archive-card
        [archivedPia]="archivedPia"
        (deleted)="refreshContent()"
        [previousArchivedPia]="i > 0 ? entries[i - 1] : null"
      >
      </app-archive-card>
      } } @case ('structure') { @for (structure of entries | filterForUser:
      searchText; let i = $index; track structure.id) {
      <app-structure-card
        (changed)="updateEntrie($event)"
        (duplicated)="refreshContent()"
        (deleted)="refreshContent()"
        [structure]="structure"
        [previousStructure]="i > 0 ? entries[i - 1] : null"
      >
      </app-structure-card>
      } } @case ('knowledgeBase') { @for (base of entries | filterForUser:
      searchText; let i = $index; track base.id) {
      <app-knowledgebase-card
        (conflictDetected)="conflictDialog($event)"
        (changed)="updateEntrie($event)"
        (duplicated)="refreshContent()"
        (deleted)="refreshContent()"
        [base]="base"
      >
      </app-knowledgebase-card>
      } } @default { } }
      <!-- ENDING PIA, ARCHIVE Cards switch -->

      } @else {
      <div class="entries-loading entries-loading-card">
        <app-loading-overlay
          [visibility]="true"
          [childMode]="true"
        ></app-loading-overlay>
      </div>
      }
    </div>
    } @else {
    <!-- "List" mode -->
    <div class="small-12 medium-12 columns">
      <table class="pia-list-table">
        <thead>
          @switch (type_entries) { @case ('structure') {
          <tr app-structure-heading (sorting)="sortBy($event)"></tr>
          } @case ('knowledgeBase') {
          <tr app-knowledgebase-heading (sorting)="sortBy($event)"></tr>
          } @default {
          <tr app-pia-heading (sorting)="sortBy($event)"></tr>
          } }
        </thead>
        @if (!loading) {
        <tbody>
          @switch (type_entries) { @case ('pia') { @for (pia of entries |
          filterForUser: searchText; let i = $index; track pia.id) {
          <tr
            app-pia-line
            class="app-list-item"
            (conflictDetected)="conflictDialog($event)"
            (changed)="updateEntrie($event)"
            (duplicated)="refreshContent()"
            (archived)="refreshContent()"
            [pia]="pia"
            [users]="users"
            (newUserNeeded)="onNewUserNeeded($event)"
          ></tr>
          } } @case ('archive') { @for (archivedPia of entries | filterForUser:
          searchText; let i = $index; track archivedPia.id) {
          <tr
            app-archive-line
            class="app-list-item"
            [archivedPia]="archivedPia"
            (deleted)="refreshContent()"
          ></tr>
          } } @case ('structure') { @for (structure of entries | filterForUser:
          searchText; let i = $index; track structure.id) {
          <tr
            app-structure-line
            class="app-list-item"
            (changed)="updateEntrie($event)"
            (duplicated)="refreshContent()"
            (deleted)="refreshContent()"
            [structure]="structure"
          ></tr>
          } } @case ('knowledgeBase') { @for (base of entries | filterForUser:
          searchText; let i = $index; track base.id) {
          <tr
            app-knowledgebase-line
            class="app-list-item"
            (conflictDetected)="conflictDialog($event)"
            (changed)="updateEntrie($event)"
            (duplicated)="refreshContent()"
            (deleted)="refreshContent()"
            [base]="base"
          ></tr>
          } } @default { } }
        </tbody>
        } @else {
        <tbody>
          <div class="entries-loading entries-loading-line">
            <app-loading-overlay
              [visibility]="true"
              [childMode]="true"
            ></app-loading-overlay>
          </div>
        </tbody>
        }
      </table>
      @if (entries.length <= 0 && !loading) {
      <div class="entries-missing">
        {{ "homepage.no_entries." + type_entries | translate }}
      </div>
      }
    </div>
    }
  </div>
</div>

@if (showModal) {
<app-modal
  [specialClass]="
    'card ' + (type_entries === 'knowledgeBase' ? 'card-knowledge' : '')
  "
  (clickOnClose)="showModal = false"
>
  @switch (type_entries) { @case ('pia') {
  <app-new-pia
    [users]="users"
    (newUserNeeded)="onNewUserNeeded($event)"
    (submitted)="onFormsubmitted($event, 'pia'); showModal = false"
  >
  </app-new-pia>
  } @case ('structure') {
  <app-new-structure
    (submitted)="onFormsubmitted($event, 'structure'); showModal = false"
  >
  </app-new-structure>
  } @case ('knowledgeBase') {
  <app-new-knowledgebase
    (submitted)="onFormsubmitted($event, 'knowledgeBase'); showModal = false"
  >
  </app-new-knowledgebase>
  } @default { } }
</app-modal>
}

<app-dialog></app-dialog>

@if (showNewUserForm) {
<app-modal specialClass="newUserForm" (clickOnClose)="onCancelUser()">
  <app-new-user
    [forceUserType]="true"
    [user]="userBehavior.value ? userBehavior.value : null"
    (userAdded)="onUserAdded($event)"
    (canceled)="onCancelUser()"
  ></app-new-user>
</app-modal>
}
